<script>
    import { uiState } from "@app/store/uiStore.js";
    import { externalDataState } from "@app/store/externalDataStore.js";
    import { modalState } from "@app/store/modalStore.js";
    import { toast } from "@zerodevx/svelte-toast";
    import { fade } from "svelte/transition";
    import { projectState } from "@app/store/projectStore.js";
    import { playerState } from "@app/store/playerStore.js";
    import { onMount } from "svelte";

    /* Firebase */
    import firebase from "@app/configs/firebase.js";

    import _Event from "@app/external/cc-lib/dist/classes/event.js";
    import _EventGroup from "@app/external/cc-lib/dist/classes/eventGroup.js";
    import _Project from "@app/external/cc-lib/dist/classes/project.js";
    import loadMedia from "@app/external/cc-lib/dist/functions/projects/loadMedia.js";

    let progress = 0,
        statusMsg = "Connecting to Iconik...",
        mediaUrl;

    async function updateStatus(statusInfo) {
        progress = statusInfo.progress;
        statusMsg = statusInfo.msg;
    }

    async function getFileSize() {
        try {
            const response = await fetch($projectState.media.path, {
                method: "HEAD",
            });
            const fileSize = response.headers.get("content-length");
            return fileSize;
        } catch (err) {
            return false;
        }
    }

    onMount(async () => {
        try {
            console.log("Getting proxy information for "+ $externalDataState.assetId);

            await updateStatus({
                progress: 10,
                msg: "Getting proxy information...",
            });

            $uiState.timeline = false;
            playerState.updateDuration(false);

            let proxyInfo = await firebase.functions().httpsCallable("v8IconikGetProxy")($externalDataState.assetId);

            // console.log(proxyInfo);

            await updateStatus({
                progress: 45,
                msg: "Reloading proxy... please wait a moment.",
            });

            mediaUrl = proxyInfo.data.objects[0].url;

            $externalDataState.mediaUrl = mediaUrl;

            await updateStatus({
                progress: 50,
                msg: "Importing media from URL...",
            });

            $projectState = loadMedia($projectState, {
                projectName: $projectState.name,
                storage: $projectState.media.storage,
                mediaUrl: mediaUrl,
                incode: 0,
                frameRate: $projectState.frameRate,
                dropFrame: $projectState.dropFrame,
                aspectRatio: "16/9"
            });

            let mediaType = $projectState.media.type === "video/quicktime" ? "video/mp4" : $projectState.media.type;                

            let fileSize = await getFileSize($projectState.media.path);
            if (fileSize) {
                const sizeInBytes = parseInt(fileSize);
                const sizeInKilobytes = sizeInBytes / 1024;
                const sizeInMegabytes = sizeInKilobytes / 1024;
                if (sizeInMegabytes < 512) {
                    $projectState.media.useFallback = false;
                }
            }

            /* Update media player global */
            player.src = { src: $projectState.media.path, type: mediaType};

            await updateStatus({
                progress: 100,
                msg: "Proxy import completed.",
            });

            toast.push(`Proxy import completed successfully`, {
                classes: ["toast-success"],
            });

            setTimeout(() => {
                $uiState.timeline = true;
                modalState.hideModal();
            }, 1000);
        } catch (err) {
            console.log(err);
            console.log(err.message);
            toast.push(`External Project Import Failed. ${err.message}`, {
                classes: ["toast-danger"],
            });
            modalState.hideModal();
        }
    });
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {$modalState === 'iconikGetProxy' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="iconikProxyTitle"
    aria-describedby="iconikProxyDescription"
    tabindex="-1"
    id="IconikGetProxyModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="iconikProxyTitle">Iconik Proxy Import</h4>
                <button
                    type="button"
                    class="btn-close"
                    id="closeIconikProxyModal"
                    aria-label="Close dialog"
                    on:click={modalState.hideModal}
                />
            </div>
            <div class="modal-body" id="iconikProxyDescription">
                <p role="status" aria-live="polite">
                    <i class="bi bi-exclamation-diamond-fill" aria-hidden="true"></i> {statusMsg}
                </p>
                <div class="progress">
                    <div
                        class="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style="width: {progress}%;"
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-label="Proxy import progress">
                        {progress}%
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
